function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import sharedCss from "./sharedCss";
import { ValidityStateContext } from "./validityState";
export const InternalUseOnlyTextArea = styled.textarea.withConfig({
  componentId: "sc-1wlqmm6-0"
})(["", ";overflow:auto;margin:0;height:8rem;"], sharedCss);
/**
 * The TextArea component is useful when the input expected from a user is more than 1 line of text.
 */

const TextArea = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    validityState,
    name,
    required,
    minLength,
    maxLength,
    value,
    defaultValue,
    onChange,
    placeholder,
    ...props
  } = _ref;
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/React.createElement(InternalUseOnlyTextArea, _extends({
    validityState: validityState ? validityState : validityStateContext,
    name: name,
    required: required,
    minLength: minLength,
    maxLength: maxLength,
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    placeholder: placeholder,
    ref: ref
  }, props));
});
TextArea.displayName = "TextArea";
TextArea.propTypes = {
  /** The current validity state of the TextArea */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),

  /** Used to reference the input in JavaScript, or to reference form data after a form is submitted */
  name: PropTypes.string,

  /** Whether the input is required to be filled out to validate */
  required: PropTypes.bool,

  /** The number of characters must not be less than the minLength value */
  minLength: PropTypes.string,

  /** The number of characters must not exceed the maxLength value */
  maxLength: PropTypes.string,

  /** The value of the TextArea */
  value: PropTypes.string,

  /** Callback to execute when the value changes */
  onChange: PropTypes.func,

  /** Default value for uncontrolled use */
  defaultValue: PropTypes.string,

  /** Text that appears within the TextArea when empty */
  placeholder: PropTypes.string
};
export default TextArea;